import * as React from 'react';
import logo from '../logo.svg';
import './Header.css';

interface WebsiteMenu {
  name: string;
  path: string;
}

export interface HeaderState {
  menus: WebsiteMenu[];
  showDropDown: boolean;
}
class Header extends React.PureComponent<{}, HeaderState> {

  constructor(props: React.ReactPropTypes) {
    super(props);

    this.state = {
      menus: [
        { name: 'Home', path: '/' },
        { name: 'Sponsorhsip', path: '/Sponsorship' },
        { name: 'Volunteering', path: '/Volunteering' },
        { name: 'What We Do', path: '/WhatWeDo' },
        { name: 'Blog', path: '/Blog' }
      ],
      showDropDown: false
    };

    this.handleClickMenu = this.handleClickMenu.bind(this);
  }

  handleClickMenu() {
    this.setState({ showDropDown: !this.state.showDropDown });
  }

  render(): JSX.Element {
    return (
      <header className="header" id="header" role="banner">
        {/* navigation start */}
        <div className="navbar">
          <div className="container">
            {/* Brand and toggle get grouped for better mobile display */}
            <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target=".navbar-collapse" onClick={this.handleClickMenu}>
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              <a className="navbar-brand" href="index.html">
                <img className="img-responsive" src={logo} />
              </a>
            </div>
            {/* Collect the nav links, forms, and other content for toggling */}
            <nav className={'collapse navbar-collapse ' + (this.state.showDropDown ? 'in' : '')}>
              <ul className="nav navbar-nav navbar-right">
                {this.state.menus.map((o: WebsiteMenu) =>
                  <li className="dropdown" key={o.name}>
                    <a href={o.path} className="dropdown-toggle" data-toggle="dropdown">{o.name}</a>
                  </li>
                )}
              </ul>
            </nav>
            {/* /.navbar-collapse */}
          </div>
          {/* /.container-fluid */}
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.tsx